export default __webpack_public_path__ + "static/media/hrhealthcare.f8b2bc53.png";